import React from "react";
import useTranslation from "next-translate/useTranslation";
import NoDataPlaceHolder from "../../../../containers/v2/ProSpaceContainer/components/NoDataPlaceHolder";
import HeaderCards from "../../../../SanityComponents/HeaderCards";

const cardsData = [
  {
    title: "Achat",
    subtitle: "Les biens en vente",
    buttonText: "Voir tout",
    buttonLink: "/list.htm?transaction_type=vente",
  },
  {
    title: "Location",
    subtitle: "Les biens à louer",
    buttonText: "Voir tout",
    buttonLink: "/list.htm?transaction_type=location",
  },
  {
    title: "Projet neuf",
    subtitle: "Les biens en vente",
    buttonText: "Voir tout",
    buttonLink: "/list.htm?transaction_type=Projets Neufs",
  },
  {
    title: "Estimation",
    subtitle: "Combien vaut mon bien ?",
    buttonText: "Estimer",
    buttonLink: "/estimation",
  },
];

import styles from "./style.module.css";
import { useRouter } from "next/router";
import formatUrl from "utils/FormatUrl";

const Redirect404 = ({ transaction_type }) => {
  const { t, lang } = useTranslation("newLp");
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <NoDataPlaceHolder
          title={t("Oops!")}
          message={t("Cette page n'existe pas")}
          from404={true}
        />
        <div className={styles.cardsContainer}>
          {cardsData.map((item, key) => {
            return (
              <HeaderCards
                key={key}
                title={item.title}
                desc={item.subtitle}
                btnText={item.buttonText}
                btnLink={formatUrl(`/${item.buttonLink}`, lang)}
                isPNBlock={item.title === "Projet neuf"}
                from404={true}
                t={t}
                lang={lang}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Redirect404;
